import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels'

const ResizableSidePanelLayout = ({
  showSidePanel,
  sidePanelSize,
  mainPanelSize,
  minPanelSize = 20,
  onLayoutChange,
  sidePanel,
  mainPanel,
  panelButton,
  sidePanelStyle = {},
  style,
}) => (
  <PanelGroup direction="horizontal" onLayout={onLayoutChange} style={style}>
    {showSidePanel && (
      <Panel order={1} defaultSize={sidePanelSize} minSize={minPanelSize} style={{ display: 'flex', ...sidePanelStyle }}>
        {sidePanel}
      </Panel>
    )}
    {showSidePanel && <PanelResizeHandle />}
    {panelButton && <Box sx={{ position: 'relative', left: 0 }}>{panelButton}</Box>}
    <Panel order={2} defaultSize={showSidePanel ? mainPanelSize : 100} minSize={minPanelSize} style={{ display: 'flex' }}>
      {mainPanel}
    </Panel>
  </PanelGroup>
)

ResizableSidePanelLayout.propTypes = {
  showSidePanel: PropTypes.bool.isRequired,
  sidePanelSize: PropTypes.number.isRequired,
  mainPanelSize: PropTypes.number.isRequired,
  minPanelSize: PropTypes.number,
  onLayoutChange: PropTypes.func.isRequired,
  sidePanel: PropTypes.node.isRequired,
  mainPanel: PropTypes.node.isRequired,
  panelButton: PropTypes.node,
  sidePanelStyle: PropTypes.object,
  style: PropTypes.object,
}

export default ResizableSidePanelLayout
